import styled from "styled-components";

export const GameReBuyInPopupWrapper = styled.div`
  position: fixed;
  top: 0px;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;

  > .content {
    position: fixed;
    width: 308px;
    border: 1px solid transparent;
    border-radius: 12px;
    background-image: linear-gradient(#000, #000),
      linear-gradient(
        to right,
        #ba643a 25%,
        #ffffff 50%,
        #7addeb 75%,
        #836623 100%
      );
    background-origin: border-box;
    background-clip: content-box, border-box;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    > .wrapper {
      font-weight: 800;
      font-size: 18px;
      color: #fff;
      padding: 20px 16px;
    }
  }
`;

export const GameReBuyInResult = styled.div`
  display: flex;
  width: 100%;
  height: 29px;
  margin-top: 20px;

  > div {
    flex: 2;
  }
  > .text {
    font-weight: 500;
    font-size: 13px;
    line-height: 29px;
    color: #a7a7a7;
  }
  > .value {
    heiht: 100%;
    border-radius: 8px;
    font-weight: 700;
    font-size: 13px;
    line-height: 29px;
    text-align: center;
    color: #fff;
    border: 1px solid #c4c4c480;
    box-shadow: 0px 4px 4px 0px #00000040;
  }
`;

export const GameReBuyInButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 30px;

  > .button {
    flex: 1;
    height: 48px;
    border-radius: 8px;
    gap: 10px;
    font-weight: 600;
    font-size: 15px;
    line-height: 48px;
    text-align: center;
    color: #c4c4c4;

    &.purple {
      background: #7f25fb;
      color: #fff;
    }
  }
`;

export const GameReBuyInScrollWrapper = styled.div`
  margin-top: 20px;
`;

export const GameReBuyInRange = styled.div`
  width: 100%;
  height: 10px;
  border-radius: 8px;
  border: 1px solid #c4c4c480;
  position: relative;

  .track {
    position: absolute;
    height: 4px;
    top: 2px;
    left: 2px;
    background: linear-gradient(
      90deg,
      #ffcd57 0%,
      #e0ad35 63.84%,
      #b68411 122.1%
    );
    border-radius: 8px;
    z-index: 1;
    pointer-events: none;
  }

  > input {
    width: calc(100% - 2px);
    height: 6px;
    background: transparent;
    position: relative;
    top: -7px;
    -webkit-appearance: none;
    appearance: none;
    outline: none;
    z-index: 1;
  }

  input::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 23px;
    width: 23px;
    border-radius: 50%;
    background-image: url("/image-web/game/slider-thumb.svg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    z-index: 3;
    position: relative;
  }
`;

export const GameReBuyInValuesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 14px;

  > .header {
    font-weight: 700;
    font-size: 13px;
    text-align: center;
  }
`;

export const GameReBuyInValues = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  > .result-value {
    width: 136px;
    height: 35px;
    border-radius: 8px;
    border-width: 1px;
    text-align: center;
    line-height: 33px;
    border: 1px solid transparent;
    background-image: linear-gradient(#000, #000),
      linear-gradient(167deg, #ffcd57 33.13%, #ffffff 50%, #b68411 76.39%);
    background-origin: border-box;
    background-clip: content-box, border-box;
  }
`;

export const GameReBuyInRangeValue = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 63px;

  > .name {
    font-weight: 700;
    font-size: 11px;
    color: #a7a7a7;
  }

  > .value {
    font-weight: 700;
    font-size: 11px;
    color: #ffdb55;
  }
`;
